import Vue from 'vue'
import Vuex from 'vuex'
import apis from './apis'
import VueCookie from 'vue-cookie'
import wx from 'weixin-js-sdk'
import Lodash from 'lodash'
import CustomConfig from './config'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// states
const state = {
  islogin: '',
  userinfo: '',
  account: '',
  account_code: '',
  searchHotKey: [],
}

// getters
const getters = {
  islogin: state => state.islogin, // 是否登录
  userinfo: state => state.userinfo, // user信息
  account: state => state.account, // 登录账号
  account_code: state => state.account_code, // 登录账号验证码
  searchHotKey: state => state.searchHotKey, // 热门搜索
}

// actions
const actions = {
  // 用户信息
  userinfo({ commit, state }, params) {
    return app.$apis.user({
      not_go_login: params.not_go_login // 是否跳转到登录
    }).then(res => {
      commit('setlogin', true)
      commit('userinfo', res.data)
      return res
    }).catch(res => {
      return res
      commit('userinfo', {})
    })
  },
  searchHotKey({ commit, state }) { // 搜索热门
    apis.searchHotKeyWord().then(res => {
      commit('searchHotKey', res.data)
    })
  },
  payOrder({commit, state}, params){
    return apis.updateOrder(params.data).then(res => {
      if(res.data.url){
        location.href = res.data.url
      }
      return res;
    })
  },
  checkOrder({commit, state}, params){
    return apis.checkPay({
      orderId: params.order_id,
    }).then(res => {
      return res
    })
  },
  appcall({commit, state}, params){
    const method_name = params.app_method;
    const data = params.app_data;
    console.log(method_name)
    console.log(data)
    if(window.android && window.android[method_name]){
      window.android[method_name](JSON.stringify(data));
    }else if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[method_name]){
      window.webkit.messageHandlers[method_name].postMessage(data);
    }else if(params.callback){
      params.callback(data)
    }
  }
}

// mutations
const mutations = {
  // 登录注册: 设置true, 接口返回401: 设置false
  setlogin(state, status) {
    state.islogin = status
  },
  // 个人中心与认证会: 设置此字段
  userinfo(state, info) {
    state.userinfo = info
  },
  // 手机&账号登录: 设置TOKEN
  setToken(state, token) {
    VueCookie.set('uooc_auth', token)
  },
  // 创建QQ咨询
  createQQ(state, token){
    let script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('src', 'https://wp.qiye.qq.com/qidian/2852156956/f9426b9bdd0c64a59d08549e87d841c2')
    script.setAttribute('id', 'qd2852156956f9426b9bdd0c64a59d08549e87d841c2')
    document.documentElement.appendChild(script)
  },
  // 销毁QQ
  destroyQQ(state, token){
    let oldscript = document.getElementById('qd2852156956f9426b9bdd0c64a59d08549e87d841c2')
    if(oldscript){
      document.documentElement.removeChild(oldscript)
    }
  },
  GOAPP(state, params){
    const tourl = params.type == 'course' && !params.goapp ? 'https://abn2qj.mlinks.cc/AbsF?cid='+ params.id : 'https://abn2qj.mlinks.cc/Absp'
    params.modal.show('dialog', {
      text: '学习本课程需使用<br>【优课UOOC】APP',
      buttons: [{
        title: '去学习',
        handler: () => {
          location.href = tourl
          params.modal.hide('dialog')
        }
      }]
    })
  },
  shareWeixin(state, params){
    if(!CustomConfig.is_weixin) return
    apis.getweixinsign({
      url: location.href
    }).then(res => {
      const wxconfig = {
        debug: false,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo'],
        success: function () {
        // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      }

      setTimeout(() => {

        // 配置微信config
        let weixinconfig = Lodash.assign(wxconfig, res.data)
        wx.config(weixinconfig)
        
        // 微信ready
        wx.ready(function(){
          
          // 配置分享链接
          params.link = params.link || location.href
          params.url = params.link
          let shareconfig = params
          
          // 配置相关分享
          wx.onMenuShareTimeline(shareconfig)
          wx.onMenuShareAppMessage(shareconfig)
          wx.onMenuShareQQ(shareconfig)
          wx.onMenuShareWeibo(shareconfig)
        })
      }, 500)
    })
  },
  account(state, account) {
    state.account = account
  },
  account_code(state, account_code) {
    state.account_code = account_code
  },
  searchHotKey(state, keys) {
    state.searchHotKey = keys
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js